// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LrDT","question":"styles_question__1S-bZ","description":"styles_description__1lilN"};